module.exports = __webpack_public_path__ + "static/media/bluetooth.7a8e91ad.svg";